import bgMario from './images/data-charactor/bg-mario.jpg';
import bgZelda from './images/data-charactor/bg-zelda.jpg';
import bgAnimal from './images/data-charactor/bg-animal.jpg';
import bgKirby from './images/data-charactor/bg-kirby.jpg';
import charAnimal from './images/data-charactor/c1.png';
import charKirby from './images/data-charactor/c2.png';
import charMario from './images/data-charactor/c3.png';
import charZelda from './images/data-charactor/c4.png';

import dataFuturedSwitch from './images/data-futured/p1.png';
import dataFuturedSwitch2 from './images/data-futured/p11.png';
import dataFuturedStarWar from './images/data-futured/p2.png';
import dataFuturedStarWar2 from './images/data-futured/p22.png';
import dataFuturedMLB from './images/data-futured/p3.png';
import dataFuturedMLB2 from './images/data-futured/p33.png';
import dataFuturedMario from './images/data-futured/p4.png';
import dataFuturedMario2 from './images/data-futured/p44.png';
import dataFuturedTriangle from './images/data-futured/p5.png';
import dataFuturedTriangle2 from './images/data-futured/p55.png';
import dataFuturedFornite from './images/data-futured/p6.png';
import dataFuturedFornite2 from './images/data-futured/p66.png';
import dataFuturedSentinal from './images/data-futured/p7.png';
import dataFuturedSentinal2 from './images/data-futured/p77.png';
import dataFuturedPokemon from './images/data-futured/p8.png';
import dataFuturedPokemon2 from './images/data-futured/p88.png';
import dataFuturedDread from './images/data-futured/p9.png';
import dataFuturedDread2 from './images/data-futured/p99.png';

import new1 from './images/data-news/n1.png';
import new2 from './images/data-news/n2.png';
import new3 from './images/data-news/n3.png';
import new4 from './images/data-news/n4.png';
import new5 from './images/data-news/n5.png';
import new6 from './images/data-news/n6.png';

import p1 from './images/data-bestSeller/p1.png';
import p11 from './images/data-bestSeller/p11.png';
import p2 from './images/data-bestSeller/p2.jpg';
import p22 from './images/data-bestSeller/p22.png';
import p3 from './images/data-bestSeller/p3.jpg';
import p33 from './images/data-bestSeller/p33.jpg';
import p4 from './images/data-bestSeller/p4.png';
import p44 from './images/data-bestSeller/p44.png';
import p5 from './images/data-bestSeller/p5.png';
import p55 from './images/data-bestSeller/p55.png';
import p6 from './images/data-bestSeller/p6.jpg';
import p66 from './images/data-bestSeller/p66.png';
import p7 from './images/data-bestSeller/p7.jpg';
import p77 from './images/data-bestSeller/p77.png';
import p8 from './images/data-bestSeller/p8.jpg';
import p88 from './images/data-bestSeller/p88.png';

import newReleases1 from './images/data-newReleases/l1.png';
import newReleases11 from './images/data-newReleases/l11.png';
import newReleases2 from './images/data-newReleases/l2.jpg';
import newReleases22 from './images/data-newReleases/l22.png';
import newReleases3 from './images/data-newReleases/l3.jpg';
import newReleases33 from './images/data-newReleases/l33.png';
import newReleases4 from './images/data-newReleases/l4.jpg';
import newReleases44 from './images/data-newReleases/l44.png';
import newReleases5 from './images/data-newReleases/l5.jpg';
import newReleases55 from './images/data-newReleases/l55.png';
import newReleases6 from './images/data-newReleases/l6.jpg';
import newReleases66 from './images/data-newReleases/l66.png';
import newReleases7 from './images/data-newReleases/l7.jpg';
import newReleases77 from './images/data-newReleases/l77.png';
import newReleases8 from './images/data-newReleases/l8.jpg';
import newReleases88 from './images/data-newReleases/l88.png';

import storeGame1 from './images/data-store-games/g1.png';
import storeGame2 from './images/data-store-games/g2.png';
import storeGame3 from './images/data-store-games/g3.png';

//Data Futured done
export const dataFutured = [
  {
    id: 1,
    title: 'Nitendo Switch Sports - Pre-order now',
    categoryName: 'Nitendo Switch',
    linkImg: dataFuturedSwitch,
    linkImg2: dataFuturedSwitch2,
    price: 59.99,
  },
  {
    id: 2,
    title: 'LEGO® Star Wars™: The Skywalker Saga',
    categoryName: 'Nitendo Switch',
    linkImg: dataFuturedStarWar,
    linkImg2: dataFuturedStarWar2,
    price: 59.99,
  },
  {
    id: 3,
    title: 'MLB The Show 22 - Available now',
    categoryName: 'Nitendo Switch',
    linkImg: dataFuturedMLB,
    linkImg2: dataFuturedMLB2,
    price: 39.99,
  },
  {
    id: 4,
    title: 'Mario Kart 8 Deluxe DLC - Available now',
    categoryName: 'Nitendo Switch',
    linkImg: dataFuturedMario,
    linkImg2: dataFuturedMario2,
    price: 59.99,
  },
  {
    id: 5,
    title: 'Triangle Strategy - Available now',
    categoryName: 'Nitendo Switch',
    linkImg: dataFuturedTriangle,
    linkImg2: dataFuturedTriangle2,
    price: 49.99,
  },
  {
    id: 6,
    title: 'Fortnite Season 3 Chapter 2 Resistance',
    categoryName: 'Nitendo Switch',
    linkImg: dataFuturedFornite,
    linkImg2: dataFuturedFornite2,
    price: 59.99,
  },
  {
    id: 7,
    title: '13 Sentinels: Aegis Rim - Pre-order now',
    categoryName: 'Nitendo Switch',
    linkImg: dataFuturedSentinal,
    linkImg2: dataFuturedSentinal2,
    price: 29.99,
  },
  {
    id: 8,
    title: 'Pokémon Legends: Arceus - Available now',
    categoryName: 'Nitendo Switch',
    linkImg: dataFuturedPokemon,
    linkImg2: dataFuturedPokemon2,
    price: 69.99,
  },
  {
    id: 9,
    title: 'Metroid Dread - Available now',
    categoryName: 'Nitendo Switch',
    linkImg: dataFuturedDread,
    linkImg2: dataFuturedDread2,
    price: 29.99,
  },
];

//Data News Card done
export const dataNewsCard = [
  {
    id: 1,
    title:
      'Nintendo Switch Online + Expansion Pack: Mario Golf is now available!',
    desc: 'It’s time to hit the green with Mario and friends! Mario is on a well-deserved break from kingdom-saving and decides to take a swing at world-class golfing action. Choose from 10 different modes of play and six 18-hole courses in a variety of environments.',
    date: '04/14/22',
    linkImg: new1,
  },
  {
    id: 2,
    title: 'When it comes to eggs, these games are no yolk!',
    desc: 'Whether you’re looking to cook ‘em, grow ‘em, or throw ‘em, when it comes to eggs, these games are no yolk. Eggs-plore the hen-teresting ways each of these games serves up grade A fun! Animal Crossing™: New Horizons: Escape to a deserted island and create your own paradise as you explore, create, and customize in the Animal Crossing: New Horizons game. Live life at your own pace as you garden, search for bugs and fossils, get to know the residents, and more',
    date: '04/14/22',
    linkImg: new2,
  },
  {
    id: 3,
    title:
      'A JRPG classic is finally coming to North America this July! Watch a new trailer',
    date: '04/13/22',
    linkImg: new3,
  },
  {
    id: 4,
    title:
      'Experience the fight to save humanity from 13 different perspectives in 13 Sentinels: Aegis Rim',
    date: '04/12/22',
    linkImg: new4,
  },
  {
    id: 5,
    title: 'Grab a friend and try to survive in Don’t Starve Together',
    date: '04/13/22',
    linkImg: new5,
  },
  {
    id: 6,
    title:
      'Check out the latest trailer for Fire Emblem Warriors: Three Hopes!',
    date: '04/12/22',
    linkImg: new6,
  },
];

//Data Charactors done
export const dataCharactors = [
  {
    id: 1,
    name: 'Super Mario™️',
    bgImg: bgMario,
    charactorImg: charMario,
  },
  {
    id: 2,
    name: 'The Legend of Zelda™️',
    bgImg: bgZelda,
    charactorImg: charZelda,
  },
  {
    id: 3,
    name: 'Animal Crossing™',
    bgImg: bgAnimal,
    charactorImg: charAnimal,
  },
  {
    id: 4,
    name: 'Kirby™️',
    bgImg: bgKirby,
    charactorImg: charKirby,
  },
];

//Data bestSeller done
export const dataDigitalBestSeller = [
  {
    id: 1,
    title: 'Mario Kart™ 8 Deluxe',
    price: 59.99,
    category: 'Nintendo Switch',
    linkImg: p1,
    linkImg2: p11,
  },
  {
    id: 2,
    title: 'TRIANGLE STRATEGY™',
    price: 59.99,
    category: 'Nintendo Switch',
    linkImg: p2,
    linkImg2: p22,
  },
  {
    id: 3,
    title: 'Pokémon™ Legends: Arceus',
    price: 59.99,
    category: 'Nintendo Switch',
    linkImg: p3,
    linkImg2: p33,
  },
  {
    id: 4,
    title: 'Super Mario™ 3D World + Bowser’s Fury',
    price: 59.99,
    category: 'Nintendo Switch',
    linkImg: p4,
    linkImg2: p44,
  },
  {
    id: 5,
    title: 'Cuphead',
    price: 19.99,
    category: 'Nintendo Switch',
    linkImg: p5,
    linkImg2: p55,
  },
  {
    id: 6,
    title: 'Minecraft',
    price: 29.99,
    category: 'Nintendo Switch',
    linkImg: p6,
    linkImg2: p66,
  },
  {
    id: 7,
    title: 'Mario + Rabbids® Kingdom Battle',
    price: 59.99,
    category: 'Nintendo Switch',
    linkImg: p7,
    linkImg2: p77,
  },
  {
    id: 8,
    title: 'Unravel Two',
    price: 19.99,
    category: 'Nintendo Switch',
    sale: 63, //percent
    linkImg: p8,
    linkImg2: p88,
  },
];

//Data Digital new releases
export const dataDigitalNewReleases = [
  {
    id: 1,
    title: 'CHRONO CROSS: THE RADICAL DREAMERS EDITION',
    price: 19.99,
    category: 'Nintendo Switch',
    status: 'New!',
    linkImg: newReleases1,
    linkImg2: newReleases11,
  },
  {
    id: 2,
    title: 'LEGO® Star Wars™: The Skywalker Saga',
    price: 59.99,
    category: 'Nintendo Switch',
    status: 'New!',
    linkImg: newReleases2,
    linkImg2: newReleases22,
  },
  {
    id: 3,
    title: 'MLB® The Show™ 22',
    price: 59.99,
    category: 'Nintendo Switch',
    status: 'New!',
    linkImg: newReleases3,
    linkImg2: newReleases33,
  },
  {
    id: 4,
    title: 'Kirby™ and the Forgotten Land',
    price: 59.99,
    category: 'Nintendo Switch',
    status: 'Free demo',
    linkImg: newReleases4,
    linkImg2: newReleases44,
  },
  {
    id: 5,
    title: 'Rune Factory 5',
    price: 19.99,
    category: 'Nintendo Switch',
    linkImg: newReleases5,
    linkImg2: newReleases55,
  },
  {
    id: 6,
    title: 'Mario Kart™ 8 Deluxe Booster Course Pass ',
    price: 24.99,
    category: 'Nintendo Switch',
    status: 'DLC bundle',
    linkImg: newReleases6,
    linkImg2: newReleases66,
  },
  {
    id: 7,
    title: 'Mario Rabbids® Kingdom Battle',
    price: 59.99,
    category: 'Nintendo Switch',
    linkImg: newReleases7,
    linkImg2: newReleases77,
  },
  {
    id: 8,
    title: 'Persona 4 Arena Ultimax',
    price: 29.99,
    category: 'Nintendo Switch',
    linkImg: newReleases8,
    linkImg2: newReleases88,
  },
];

export const dataStoreGames = [
  {
    id: 1,
    title: 'Nintendo Switch new releases',
    btnText: 'See full list',
    linkImg: storeGame1,
    category: 'news',
  },
  {
    id: 2,
    title: 'Nintendo Switch™ Sports',
    price: 39.99,
    category: 'Nitendo Switch',
    linkImg: dataFuturedSwitch,
  },
  {
    id: 3,
    title: 'Kirby™ and the Forgotten Land',
    price: 59.99,
    category: 'Nitendo Switch',
    linkImg: newReleases4,
  },
  {
    id: 4,
    title: 'STAR WARS™: The Force Unleashed™',
    price: 19.99,
    category: 'Nitendo Switch',
    linkImg: storeGame2,
  },
  {
    id: 5,
    title: '13 Sentinels: Aegis Rim - Pre-order now',
    price: 29.99,
    category: 'Nitendo Switch',
    linkImg: dataFuturedSentinal,
  },
  {
    id: 6,
    title: 'LEGO® Star Wars™: The Skywalker Saga',
    price: 59.99,
    category: 'Nitendo Switch',
    linkImg: dataFuturedStarWar,
  },
  {
    id: 7,
    title: 'MLB The Show 22 - Available now',
    price: 39.99,
    category: 'Nitendo Switch',
    linkImg: dataFuturedMLB,
  },
  {
    id: 8,
    title: 'Mario Kart 8 Deluxe DLC - Available now',
    category: 'Nitendo Switch',
    linkImg: dataFuturedMario,
    price: 59.99,
  },
  {
    id: 9,
    title: 'Triangle Strategy - Available now',
    price: 49.99,
    category: 'Nitendo Switch',
    linkImg: dataFuturedTriangle,
  },
  {
    id: 10,
    title: 'Fortnite Season 3 Chapter 2 Resistance',
    price: 59.99,
    category: 'Nitendo Switch',
    linkImg: dataFuturedFornite,
  },
  {
    id: 11,
    title: 'Pokémon Legends: Arceus - Available now',
    price: 69.99,
    category: 'Nitendo Switch',
    linkImg: dataFuturedPokemon,
  },
  {
    id: 12,
    title: 'Jump into Spring',
    btnText: 'See full list',
    linkImg: storeGame3,
    category: 'news',
  },
  {
    id: 13,
    title: 'Metroid Dread - Available now',
    price: 29.99,
    category: 'Nitendo Switch',
    linkImg: dataFuturedDread,
  },
  {
    id: 14,
    title: 'Super Mario™ 3D World + Bowser’s Fury',
    price: 59.99,
    category: 'Nintendo Switch',
    linkImg: p4,
  },
  {
    id: 15,
    title: 'Cuphead',
    price: 19.99,
    category: 'Nintendo Switch',
    linkImg: p5,
  },
  {
    id: 16,
    title: 'Minecraft',
    price: 29.99,
    category: 'Nintendo Switch',
    linkImg: p6,
  },
  {
    id: 17,
    title: 'Mario + Rabbids® Kingdom Battle',
    price: 59.99,
    category: 'Nintendo Switch',
    linkImg: p7,
  },
  {
    id: 18,
    title: 'Unravel Two',
    price: 19.99,
    category: 'Nintendo Switch',
    linkImg: p8,
  },
];
